import {AuthApplication} from '@application/Auth';
import {useEffect} from 'react';

export const useRefreshSession = (): void => {
  useEffect(() => {
    AuthApplication.refreshSession();
  }, []);
};
